import { isAxiosError } from 'axios';
import { PrecedenceRefusal } from '@/api/generated/schemas';
import type { RevenueCatBillingPeriodPrecedenceRefusal } from '@/api/generated/schemas';

const REFUSAL_CODES: readonly string[] = Object.values(PrecedenceRefusal);

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

/**
 * The structured 409 body of ``give_precedence``, or undefined for any other
 * error — the caller's cue to fall back to the generic toast. An unknown
 * ``code`` is rejected too: the modal has no translation to show for it.
 */
export const extractPrecedenceRefusal = (
  error: unknown
): RevenueCatBillingPeriodPrecedenceRefusal | undefined => {
  if (!isAxiosError(error) || error.response?.status !== 409) return undefined;
  const data: unknown = error.response.data;
  if (!isRecord(data) || !isRecord(data.detail)) return undefined;

  const { code, message, entitlement_ids } = data.detail;
  if (typeof code !== 'string' || !REFUSAL_CODES.includes(code)) {
    return undefined;
  }

  return {
    code: code as PrecedenceRefusal,
    message: typeof message === 'string' ? message : '',
    entitlement_ids: Array.isArray(entitlement_ids)
      ? entitlement_ids.filter((id): id is number => typeof id === 'number')
      : [],
  };
};
